module.exports = __webpack_public_path__ + "img/logo_base.60fe381e.png";